import { format } from 'date-fns';
import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';

export const getDataTableColumns = (handleViewClick: (row: MuaHangRecord) => void): DataTableColumn[] => [
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: params => {
      const status = params.row.status;
      switch (status) {
        case '0':
          return 'Chưa ghi sổ';
        case '3':
          return 'Chờ duyệt';
        case '5':
          return 'Đã ghi sổ';
      }
    }
  },
  {
    field: 'so_ct',
    headerName: 'Số chứng từ',
    width: 150,
    renderCell: params => (
      <button
        onClick={e => {
          e.stopPropagation();
          handleViewClick(params.row);
        }}
        className='hover:text-blue-500 hover:underline'
      >
        {params.row.so_ct}
      </button>
    )
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 120,
    renderCell: params => format(params.row.ngay_ct, 'dd/MM/yyyy')
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200
  },
  {
    field: 't_ps_no_nt',
    headerName: 'Tổng phát sinh',
    width: 150
  },
  {
    field: 'ma_nt',
    headerName: 'Ngoại tệ',
    width: 120,
    renderCell: params => params.row.ma_nt_data?.ma_nt || ''
  },
  {
    field: 'username0',
    headerName: 'Người tạo',
    width: 120
  },
  {
    field: 'datetime0',
    headerName: 'Ngày tạo',
    width: 120,
    renderCell: params => (params.row.datetime0 ? format(new Date(params.row.datetime0), 'dd/MM/yyyy HH:mm') : '')
  },
  {
    field: 'username2',
    headerName: 'Người sửa',
    width: 120
  },
  {
    field: 'datetime2',
    headerName: 'Ngày sửa',
    width: 120,
    renderCell: params => (params.row.datetime2 ? format(new Date(params.row.datetime2), 'dd/MM/yyyy HH:mm') : '')
  }
];

export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'tk',
    headerName: 'Tài khoản',
    width: 120,
    renderCell: params => params.row.tk_data?.code || ''
  },
  {
    field: 'ten_tk',
    headerName: 'Tên tài khoản',
    width: 200,
    renderCell: params => params.row.tk_data?.name || ''
  },
  {
    field: 'ma_kh',
    headerName: 'Mã đối tượng',
    width: 120,
    renderCell: params => params.row.ma_kh_data?.customer_code || ''
  },
  {
    field: 'ten_kh',
    headerName: 'Tên đối tượng',
    width: 200,
    renderCell: params => params.row.ma_kh_data?.customer_name || ''
  },
  {
    field: 'ps_no_nt',
    headerName: 'Ps nợ VND',
    width: 120
  },
  {
    field: 'ps_co_nt',
    headerName: 'Ps có VND',
    width: 120
  },
  {
    field: 'nh_dk',
    headerName: 'Nhóm',
    width: 120
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 120
  },
  {
    field: 'ngay_ct0',
    headerName: 'Ngày hóa đơn',
    width: 120
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 120
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 120
  }
];

export const historyColumns: DataTableColumn[] = [
  { field: 'username', headerName: 'Tài khoản', width: 100 },
  { field: 'nickname', headerName: 'Tên tài khoản', width: 200 },
  { field: 'action', headerName: 'Hành động', width: 100 },
  { field: 'datetime0', headerName: 'Thời gian', width: 150 }
];
